import localStorageService from '../../utils/local-storage-service'
import * as types from '../mutation-types'

const localStorageKey = 'currentTenant'

const state = {
  get tenantInfo () {
    let data = localStorageService.getItem(localStorageKey)
    return data || {account: null, name: ''}
  },
  set tenantInfo (v) {
    localStorageService.setItem(localStorageKey, v)
  }
}

const actions = {
  SetCurrentTenant ({ commit }, data) {
    commit(types.CurrentTenantSet, data)
  },
  ClearCurrentTenantInfo ({ commit }) {
    commit(types.CurrentTenantClear)
  }
}

const mutations = {
  [types.CurrentTenantSet] (state, data) {
    state.tenantInfo = {
      account: data.account,
      name: data.name
    }
  },
  [types.CurrentTenantClear] (state) {
    localStorageService.removeItem(localStorageKey)
    state.tenantInfo = { ...state.tenantInfo }
  }
}

export default {
  state,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/current-tenant.js